import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_QUOTE_PRODUCT_MUTATION = gql`
  mutation AddQuoteProductMutation($product: TBL_QUOTEPRODUCTS_Input) {
    addQuoteProduct(product: $product)
  }
`;

const UPDATE_QUOTE_PRODUCT_MUTATION = gql`
  mutation UpdateQuoteProductMutation($productid: ID!, $product: TBL_QUOTEPRODUCTS_Input) {
    updateQuoteProduct(PRODUCTID: $productid, product: $product)
  }
`;

const DELETE_QUOTE_PRODUCT_MUTATION = gql`
  mutation DeleteQuoteProductMutation($productid: ID!) {
    deleteQuoteProduct(PRODUCTID: $productid)
  }
`;

export default function useQuoteProductMutate() {
  const { mutate: addMutate } = useMutation(ADD_QUOTE_PRODUCT_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_QUOTE_PRODUCT_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_QUOTE_PRODUCT_MUTATION);

  async function addQuoteProduct(product) {
    try {
      const { data } = await addMutate({ product });
      return data;
    } catch (error) {
      console.error('Error adding quote product:', error);
      addAlert(error?.message || 'Error adding quote product', 'high', 4);
      return null;
    }
  }

  async function updateQuoteProduct(productid, product) {
    try {
      const { data } = await updateMutate({ productid, product });
      return data;
    } catch (error) {
      console.error('Error updating quote product:', error);
      addAlert(error?.message || 'Error updating quote product', 'high', 4);
      return null;
    }
  }

  async function deleteQuoteProduct(productid) {
    try {
      const { data } = await deleteMutate({ productid });
      return data;
    } catch (error) {
      console.error('Error deleting quote product:', error);
      addAlert(error?.message || 'Error deleting quote product', 'high', 4);
      return null;
    }
  }

  return {
    addQuoteProduct,
    updateQuoteProduct,
    deleteQuoteProduct,
  };
}
